import { ChatMessageData } from '../../../../generated/api';
import { ChatMessage, ChatMessageType } from '../models/chatMessage';
import { ChatUser } from '../models/chatUser';

export function privateMessageEventDataToChatMessage(
  remoteMsg: ChatMessageData,
  users?: ChatUser[],
): ChatMessage {
  let quoteMsg: any;
  try {
    quoteMsg = remoteMsg.quoteMsg ? JSON.parse(remoteMsg.quoteMsg) : null;
  } catch (e) {
    console.error('convert quote message error', remoteMsg, e);
  }

  const fromUser = users?.find(item => item.userId === remoteMsg.fromUserId);
  const toUser = users?.find(item => item.userId === remoteMsg.toUserId);
  const content = safeParseMessageContent(remoteMsg);

  return {
    messageId: remoteMsg.messageId,
    clientId: remoteMsg.clientId,
    from: {
      userId: remoteMsg.fromUserId,
      name: remoteMsg.fromNickname || fromUser?.name || '',
      avatar: remoteMsg.fromAvatar || fromUser?.avatar || '',
    },
    to: {
      userId: remoteMsg.toUserId,
      name: remoteMsg.toNickname || toUser?.name || '',
      avatar: remoteMsg.toAvatar || toUser?.avatar || '',
    },
    roomId: remoteMsg.sessionId,
    sessionId: remoteMsg.sessionId,
    chatSessionId: remoteMsg.chatSessionId,
    time: new Date(remoteMsg.createdAt).getTime(),
    type: remoteMsg.messageType as ChatMessageType,
    customType: undefined,
    text: remoteMsg.text,
    content,
    quoteMsg,
  };
}

function parseJSONSerializedContent(msg: ChatMessageData, s: string) {
  const obj = JSON.parse(s);
  switch (msg.messageType) {
    case ChatMessageType.Text:
      return 'text' in obj
        ? obj
        : {
            text: msg.text ?? '',
          };
    case ChatMessageType.Picture:
      return 'imageContent' in obj ? obj.imageContent ?? {} : obj;

    case ChatMessageType.Video:
      return 'videoContent' in obj ? obj.videoContent ?? {} : obj;

    case ChatMessageType.Order:
      return 'orderContent' in obj ? obj.orderContent ?? {} : obj;

    case ChatMessageType.Product:
      return 'productContent' in obj ? obj.productContent ?? {} : obj;
  }
  return obj;
}

function safeParseMessageContent(msg: ChatMessageData): any {
  if (msg.content == null) return {};

  try {
    if (typeof msg.content === 'string') {
      if (msg.content.startsWith('{')) {
        let content = parseJSONSerializedContent(msg, msg.content);
        if (
          'text' in content &&
          typeof content.text === 'string' &&
          content.text.startsWith('{')
        ) {
          content = JSON.parse(content.text);
        }
        return content;
      }

      // raw text message content string
      if (
        msg.messageType === ChatMessageType.Text ||
        msg.messageType === ChatMessageType.SystemMessage
      ) {
        return { text: msg.content || msg.text };
      }
    }
    return msg.content;
  } catch (e) {
    console.error('error parse message content: ', e);
  }
  return {};
}
